import React from 'react';
import VideoRender from './VideoRender';

function VideoBlogContainerCard() {
    return (
        <>
            <div className='med-home-banner'>
                <div className='med-container'>
                    <VideoRender />
                </div>
            </div>
        </>
    )
}

export default VideoBlogContainerCard;
